import { type FC, type ReactNode, type MouseEvent } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { Arrow } from '../../components/global/Arrow/Arrow';

import styles from './SharedPaginationArrowItem.scss';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode;
    href?: string;
    isLeft?: boolean;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    dataTn?: string;
};

export const SharedPaginationArrowItem: FC<Props> = ({
    children,
    href,
    isLeft = false,
    onClick,
    dataTn,
}) => {
    return (
        <Link
            className={classnames(
                styles.arrowItem,
                dibsCss.flex,
                dibsCss.itemsCenter,
                dibsCss.sassyFontSubHeaderSizeNoneTypeNormal,
                {
                    [styles.isLeft]: isLeft,
                }
            )}
            dataTn={dataTn}
            onClick={onClick}
            href={href}
        >
            {!isLeft && children}
            <span
                className={classnames(
                    dibsCss.w18px,
                    dibsCss.h18px,
                    isLeft ? dibsCss.mrXsmall : dibsCss.mlXsmall
                )}
            >
                <Arrow isLeft={isLeft} />
            </span>
            {isLeft && children}
        </Link>
    );
};
